import { render } from "./ConfirmOrderDiscount.vue?vue&type=template&id=5aa84b3a&scoped=true"
import script from "./ConfirmOrderDiscount.vue?vue&type=script&lang=js"
export * from "./ConfirmOrderDiscount.vue?vue&type=script&lang=js"

import "./ConfirmOrderDiscount.vue?vue&type=style&index=0&id=5aa84b3a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5aa84b3a"]])

export default __exports__